import { Component, forwardRef, signal } from '@angular/core';
import { TabComponent } from '../../../components/tab/tab.component';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';
import { TableComponent } from '../../../components/table/table.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';
import { ButtonDirective } from '../../../components/button/button.directive';
import { TableRow } from '../../../components/table/table.interface';

@Component({
  selector: 'app-sales',
  imports: [TabLayoutComponent, APITableComponent],
  providers: [
    { provide: TabComponent, useExisting: forwardRef(() => SalesComponent) },
  ],
  templateUrl: './sales.component.html',
  styleUrl: './sales.component.scss',
})
export class SalesComponent extends TabComponent {
  override name: string = this.dictionaryService.get('SalesPerformance');

  onInit() {
    // Don't initialize on component init
  }

  public async main(): Promise<void> {}
}
